import { render, staticRenderFns } from "./NewWidget.vue?vue&type=template&id=3c21560f&"
import script from "./NewWidget.vue?vue&type=script&lang=js&"
export * from "./NewWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports